export default __webpack_public_path__ + "static/6-ef939909a1d8286884ca5f84a9d421e3.jpg";